import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=98eff9ee&scoped=true&lang=pug&"
import script from "./dynamic.vue?vue&type=script&setup=true&lang=js&"
export * from "./dynamic.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=98eff9ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eff9ee",
  null
  
)

export default component.exports